import type { FaireProductEntity } from "../../entity_types/product";

export const p_atqp6kt2yw: FaireProductEntity = {
  token: "p_atqp6kt2yw",
  type: "product",
  name: "Chirps and Cheers Flat Note Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/39fa51e59222dee4f57e9fb95043a750f253834e24a5c1e7a9fd33b15975eee3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bfc2a093abaa9d37389f2a4cb19d06fde7ac341af99ec80ed46ab9b5d492b034.jpeg",
    "https://cdn.faire.com/fastly/388885f808ace3c73fb6040bddf06f4cef5b4234fba3f4faa25307a5e89bff4b.jpeg",
  ],
  priceDollars: 8,
  description:
    'A flat note is concise and smart. Not ostentatious, but clever. And without too much room, you can get right to the point, or be "well-edited" as we like to say.\n\nThis set includes 8 envelopes and 8 beautifully illustrated notecards, each with an extra illustration on the back',
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:32.969Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
